import $ from 'jquery';
import './js-cookie';
import Cookies from 'js-cookie'
import './csrf-setup';
import Translator from 'bazinga-translator';
import anime from "animejs";
import '../css/ui.scss';
import { id } from './utils/id-generator';

const devid = !Cookies.get('devid') ? id(32) : Cookies.get('devid');
Cookies.set('devid', devid, {
    expires: 365,
    secure: true,
    sameSite: 'strict',
});

global.anime = anime;
global.Translator = Translator;
global.$ = $;
window.$ = $;

Array.prototype.insert = function (index, item) {
    this.splice(index, 0, item);
};

import '../css/app.css';
import '../css/primevue.scss';
import '../css/notifications.scss';
import 'select2';
import 'bootstrap';
import '@fortawesome/fontawesome-free/scss/fontawesome.scss';


document.addEventListener('DOMContentLoaded', () => {
    const body = document.querySelector('body');
    const header = document.querySelector('.header');
    document.querySelectorAll('.navi-mobile-toggle').forEach((el) => {
        el.addEventListener('click', () => {
            const target = el.dataset.target;
            body.style.overflowY = 'hidden';
            header.classList.add('active');
            const staticBanner = document.querySelector('.static-banner');
            if (staticBanner) {
                staticBanner.style.display = 'none';
            }
            document.querySelectorAll('.navi-mobile-close').forEach(el => el.style.display = 'block');
            const menu = document.querySelector(`.navi-mobile[data-toggle='${target}'`)
            $(menu).fadeIn(100);
        })
    })

    document.querySelectorAll('.navi-close').forEach((el) => {
        el.addEventListener('click', () => {
            body.style = '';
            header.classList.remove('active');
            el.style = '';
            const staticBanner = document.querySelector('.static-banner');
            if (staticBanner) {
                staticBanner.style.display = 'block';
            }
            document.querySelectorAll('.navi-mobile').forEach(el => $(el).fadeOut(100));
            document.querySelectorAll('.navi-mobile-close').forEach(e => e.style = '');
        })
    })

    document.querySelectorAll('.navi-mobile-close').forEach((el) => {
        el.addEventListener('click', () => {
            body.style = '';
            header.classList.remove('active');
            el.style = '';
            document.querySelectorAll('.navi-mobile').forEach(el => $(el).fadeOut(100));
            const staticBanner = document.querySelector('.static-banner');
            if (staticBanner) {
                staticBanner.style.display = 'block';
            }
        })
    })

    window.addEventListener("resize", (e) => {
        if (window.innerWidth >= 576) {
            document.querySelectorAll('.navi-mobile').forEach(el => el.style.display = 'none');
            document.querySelectorAll('.navi-mobile-close').forEach(el => el.style = '');

            if (!document.querySelectorAll('.filters-sidebar.active')) {
                header.classList.remove('active');
            }
        }
    })
})
